import React, {Component, Fragment} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import HeaderInputModifying from "./components/HeaderInputModifying";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import * as R from "ramda";
import DetailInputModifying from "./components/DetailInputModifying";
import Api from "../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {formGroupBBNIndividu} from "./config";
import {initialData} from "./util";
import {connect} from "react-redux";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {fetchDataAsync} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleButton from "../../../../modules/commons/SimpleButton";

class PenyerahanBBNIndividuModifying extends Component {
    listTabPanel = ["STNK", "Lembar Pajak", "Plat Kendaraan", "BPKB"];
    listTabValue = ["STNK", "PAJAK", "PLAT", "BPKB"];

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            activeTab: "STNK",
            dataDetail: {},
            dataTable: [],
            namaPembeli: null,
            alertInfo: {
                visible: false,
                title: null,
                content: null,
            }
        }
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    }

    handleTabChange = (tab) => {
        this.setState((prevState) => ({
            ...prevState,
            activeTab: tab,
        }))
    }

    base64ToFile = (base64, filename) => {
      const arr = base64.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    };

    constructPayload = (value)=>{
        const { receiverPhoto, idPhoto, suratKuasa, sidikJari, ...rest } = value;
        const formData = new FormData();
        formData.append("input",
            new Blob([JSON.stringify(rest)], { type: "application/json" })
        );
    
        if (receiverPhoto) {
            formData.append("receiverPhoto", this.base64ToFile(receiverPhoto, 'photo.png'));
        }
        if (idPhoto) {
            formData.append("idPhoto", this.base64ToFile(idPhoto, 'photo.png'));
        }
        if (suratKuasa) {
            formData.append("suratKuasa", this.base64ToFile(suratKuasa, 'photo.png'));
        }
        if (sidikJari) {
            formData.append("sidikJari", this.base64ToFile(sidikJari, 'photo.png'));
        }
        return formData;
    }

    handleSubmit = async (payload) => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION_MULTIPART").savePenyerahanBBNIndividu,
            menuName: "Penyerahan BBN - Individu",
            setError: this.props.setError,
            args: this.constructPayload(payload),
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.props.onClickClose("close");
        }
        const message = res.data?.message || "";
        if(message?.startsWith("Pengajuan tidak dapat dilakukan ")){
            this.handleAlertInfoVisibility("Informasi", res.data.message || "Terjadi Kesalahan pada server");
        }
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").findDetailPenyerahanBBNIndividu,
            menuName: "Penyerahan BBN Individu",
            setError: this.props.setError,
            args: this.props.selectedData.processBbnId,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            const processBbnId = this.props.selectedData.processBbnId;
            this.setState((prevValue) => ({
                ...prevValue,
                namaPembeli: res.data.data.buyer,
                dataDetail: {
                    ...res.data.data,
                    STNK: initialData(res.data.data.stnk, this.props.user, processBbnId, "STNK"),
                    PAJAK: initialData(res.data.data.pajak, this.props.user, processBbnId, "PAJAK"),
                    PLAT: initialData(res.data.data.plat, this.props.user, processBbnId, "PLAT"),
                    BPKB: initialData(res.data.data.bpkb, this.props.user, processBbnId, "BPKB"),
                },
            }));
        }
    }

    handleAlertInfoVisibility = (title = null, content = null) => {
        this.setState((prevValue) => ({
            ...prevValue,
            alertInfo: {
                visible: !prevValue.alertInfo.visible,
                title: title,
                content: content,
            },
        }));
    }

    render() {
        return (
            <Fragment>
                <SimpleModal
                    title="Detail Penyerahan BBN Pelanggan"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <HeaderInputModifying
                                {...this.props}
                                dataDetail={this.state.dataDetail}
                            />

                            <Tabs onSelect={(index) => this.handleTabChange(this.listTabValue[index])}>
                                <TabList>
                                    {this.listTabPanel.map((tab, index) => (
                                        <Tab key={index} id={`button_navigate_${tab.toLowerCase()}`}>
                                            {tab}
                                        </Tab>
                                    ))}
                                </TabList>
                                {!R.isNil(this.state.dataDetail[this.state.activeTab]) && this.listTabPanel.map((item, index) => {
                                    return (
                                        <TabPanel key={`${index}-${item}`}>
                                            <DetailInputModifying
                                                id={`${index}-${item}`}
                                                {...this.props}
                                                namaPembeli={this.state.namaPembeli}
                                                triggerLoading={this.handleTriggerLoading}
                                                formGroup={formGroupBBNIndividu[this.state.activeTab]}
                                                initialValues={this.state.dataDetail[this.state.activeTab]}
                                                dataDetail={this.state.dataDetail}
                                                tab={this.state.activeTab}
                                                provinceOptions={this.state.provinceOptions}
                                                onSubmit={this.handleSubmit}
                                            />
                                        </TabPanel>
                                    );
                                })}
                            </Tabs>
                           {this.state.alertInfo?.visible && (
                              <SimpleAlert
                                title={this.state.alertInfo?.title}
                                content={<p>{this.state.alertInfo?.content}</p>}
                                visible={this.state.alertInfo?.visible}
                                onClickClose={()=>this.handleAlertInfoVisibility()}
                                additionalButtons={
                                  <SimpleButton
                                    type="button"
                                    text="OK"
                                    onClick={() => this.handleAlertInfoVisibility()}
                                  />
                                }
                              />
                            )}
                        </ModalContainer>
                    }
                />

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PenyerahanBBNIndividuModifying);
